import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { ConsultorioPrivadoService } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-privado.service';
import { ConsultorioPrivadoRequest, ConsultorioPrivadoResponse } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-privado.model';
import { ConsultorioCertificadoService } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-certificado.service';
import { ConsultorioCertificadoRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-certificado.model';

@Injectable({ providedIn: 'root' })
/** Fachada de dados gerais e certificados do consultório privado. */
export class ConsultorioDadosGeraisFeatureService extends CustomService {
    private readonly consultorioCore = inject(ConsultorioPrivadoService);
    private readonly consultorioCertificado = inject(ConsultorioCertificadoService);

    buscar(params: ConsultorioPrivadoRequest): Observable<ConsultorioPrivadoResponse[]> {
        return this.consultorioCore.buscar(params).pipe(catchError(this.handleError));
    }

    buscarCertificadosMedico(params: ConsultorioPrivadoRequest): Observable<ConsultorioCertificadoRequest[]> {
        // Usa o endpoint padrão de consulta por consultório (sem o sufixo "/medico/consulta")
        // pois é o disponível na API e retorna a lista de certificados do consultório informado.
        return this.consultorioCertificado.buscar(params).pipe(catchError(this.handleError));
    }
}
